namespace GeniuzPOS.InitialData {
    export class PsCurrencyColumns {
        static columnsKey = 'InitialData.PsCurrency';
    }
}
